// API
export const GET_WALLETS_TRANSACTIONS_API = 'wallets/transactions';
export const GET_WALLETS_CURRENT_API = 'wallets/current';
export const POST_WALLETS_TOPUP_API = 'wallets/topup';
export const POST_WALLETS_TOPUP_CODE_API = 'wallets/topup/code';

// Queries
export const QUERY_WALLETS_CURRENT = 'QUERY_WALLETS_CURRENT';
